import { CoreMenu } from '@core/types';
import { RoleType } from 'app/server/enums/role-type';

export const universityMenu: CoreMenu[] = [
	{
		id: 'home',
		title: 'Dashboard',
		translate: 'menu_univ_home',
		type: 'item',
		icon: 'home',
		url: 'university/home',
	},
	{
		id: 'schools',
		title: 'Specializzazioni',
		translate: 'menu_univ_schools',
		type: 'item',
		icon: 'school',
		url: 'university/schools',
		permissions: ['university_schools.view'],
	},
	{
		id: 'statistics',
		title: 'Statistiche',
		translate: 'menu_statistics',
		type: 'item',
		icon: 'chart-column',
		url: 'university/statistics',
		permissions: ['reports.view'],
	},
	{
		id: 'users',
		title: 'Utenti',
		translate: 'menu_univ_users',
		type: 'item',
		icon: 'users',
		url: 'university/users',
		permissions: ['university_users.view'],
	},
	{
		id: 'contacts',
		title: 'Contatti',
		translate: 'menu_univ_contacts',
		type: 'item',
		icon: 'phone',
		url: 'university/contacts',
		permissions: ['university_contacts.view'],
	},
	{
		id: 'facilities',
		title: 'Strutture',
		translate: 'menu_univ_facilities',
		type: 'collapsible',
		icon: 'hospital',
		children: [
			// Presidi - Istituti
			{
				id: 'hospital-locations',
				title: 'Presidi - Istituti',
				translate: 'menu_univ_hospital_locations',
				type: 'item',
				url: 'university/hospital-locations',
				permissions: ['university_hospital_locations.view'],
			},
			// Unità Operative - Strutture Scientifiche
			{
				id: 'operational-units',
				title: 'Unità Operative - Strutture Scientifiche',
				translate: 'menu_univ_operational_units',
				type: 'item',
				url: 'university/operational-units',
				permissions: ['university_operational_units.view'],
			},
		],
	},

	// Profili e permessi
	{
		id: 'activities',
		title: 'Attività',
		translate: 'menu_univ_activities_section',
		type: 'collapsible',
		icon: 'book',
		children: [
			{
				id: 'autonomies',
				title: 'Dettaglio Autonomie',
				translate: 'menu_univ_autonomies_detail',
				type: 'item',
				url: 'university/autonomies',
				permissions: ['university_autonomies.view'],
			},
			{
				id: 'cfu-types',
				title: 'Gestione CFU',
				translate: 'menu_univ_cfu_types',
				type: 'item',
				url: 'university/cfu-types',
				permissions: ['university_cfu_types.view'],
			},
		],
	},

	// Turni
	{
		id: 'shifts',
		title: 'Turni',
		translate: 'menu_univ_shifts',
		type: 'collapsible',
		icon: 'clock',
		children: [
			{
				id: 'shifts',
				title: 'Gestione Turni',
				translate: 'menu_univ_shifts_management',
				type: 'item',
				url: 'university/shifts',
				permissions: ['university_shifts.view'],
			},
			{
				id: 'shift-email-templates',
				title: 'Template lettere incarico',
				translate: 'menu_univ_shift_email_templates',
				type: 'item',
				url: 'university/shift-email-templates',
				permissions: ['university_shift_email_templates.view'],
			},
		],
	},

	// Rotazioni
	{
		id: 'rotations',
		title: 'Rotazioni',
		translate: 'menu_univ_rotations_section',
		type: 'collapsible',
		icon: 'rotate',
		children: [
			{
				id: 'rotations',
				title: 'Gestione Rotazioni',
				translate: 'menu_univ_rotations_management',
				type: 'item',
				url: 'university/rotations',
				permissions: ['university_rotations.view'],
			},
			{
				id: 'rotation-email-templates',
				title: 'Template lettere assegnazione',
				translate: 'menu_univ_rotation_email_templates',
				type: 'item',
				url: 'university/rotation-email-templates',
				permissions: ['university_rotation_email_templates.view'],
			},
		],
	},

	// Convenzioni
	{
		id: 'agreements',
		title: 'Convenzioni',
		translate: 'menu_univ_agreements',
		type: 'item',
		url: 'university/agreements',
		icon: 'file-contract',
		permissions: ['university_agreements.view'],
	},

	// Carriere
	{
		id: 'careers',
		title: 'Carriere',
		translate: 'menu_univ_careers',
		type: 'item',
		url: 'university/careers',
		icon: 'briefcase',
		permissions: ['university_careers.view'],
	},

	// Sospensive
	{
		id: 'suspensions',
		title: 'Sospensive',
		translate: 'menu_univ_suspensions',
		type: 'item',
		url: 'university/suspensions',
		icon: 'ban',
		permissions: ['university_suspensions.view'],
	},

	// Impostazioni Ateneo
	{
		id: 'university-settings-section',
		title: 'Impostazioni',
		translate: 'menu_univ_configurations_section',
		type: 'collapsible',
		icon: 'sliders-h',
		children: [
			{
				id: 'university_customizations',
				title: 'Personalizzazioni Ateneo',
				translate: 'menu_univ_customizations',
				type: 'item',
				icon: 'sliders-h',
				url: 'university/customizations',
				permissions: ['university_customizations.view'],
			},
			{
				id: 'university_configurations',
				title: 'Configurazioni Ateneo',
				translate: 'menu_univ_configurations',
				type: 'item',
				icon: 'cog',
				url: 'university/configurations',
				permissions: ['university_configurations.view'],
			},
			{
				id: 'university_cineca',
				title: 'Cineca',
				translate: 'menu_univ_cineca',
				type: 'item',
				icon: 'database',
				url: 'university/cineca',
				permissions: ['university_cineca.view'],
			},
			{
				id: 'internship_evaluation_questions',
				title: 'Domande Valutazione Tirocini',
				translate: 'menu_univ_internship_evaluation_questions',
				type: 'item',
				icon: 'list',
				url: 'university/internship-evaluation-questions',
				permissions: ['internship_evaluation_questions.view'],
			},
		],
	},

	// University communications
	{
		id: 'university-communications',
		title: 'Log Comunicazioni',
		translate: 'menu_admin_communications',
		type: 'item',
		icon: 'envelope',
		url: 'university/communications',
		permissions: ['university_communications.view'],
	},
	// Ruoli degli utenti dell'ateneo (#17531): la stessa pagina del multi-tenant, solo SuperAdmin, filtrata sugli utenti
	// con una credenziale nell'ateneo. "Gestione Ruoli" resta solo nel multi-tenant perché ruoli e permessi sono globali
	{
		id: 'university-admin-users',
		title: 'Gestione Ruoli Utenti',
		translate: 'menu_admin_users',
		type: 'item',
		icon: 'user-shield',
		url: 'university/admin/users',
		roles: [RoleType.SuperAdmin],
		permissions: ['admin_users.view'],
	},
	// Report (come nel multi-tenant; "I miei Report" è filtrato sull'ateneo corrente, la coda solo per il SuperAdmin)
	{
		id: 'reports-section',
		title: 'Report',
		translate: 'menu_reports_section',
		type: 'collapsible',
		icon: 'file-alt',
		children: [
			{
				id: 'my-reports',
				title: 'I miei Report',
				translate: 'menu_my_reports',
				type: 'item',
				url: 'university/my-reports',
				permissions: ['reports.view'],
			},
			{
				id: 'admin-reports-queue',
				title: 'Coda Report',
				translate: 'menu_admin_reports_queue',
				type: 'item',
				url: 'university/reports-queue',
				roles: [RoleType.SuperAdmin],
				permissions: ['admin_reports.view'],
			},
		],
	},
];
